import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Alert, Autocomplete, Card, CardContent, FormControlLabel, MenuItem, Switch, TextField, Typography } from '@mui/material';

export default function CouponAudience({ coupon, onChange }) {
    const { categories = [], brands = [] } = useSelector(state => state.shop);
    const scope = coupon.eligibility || { mode: 'all', categories: [], brands: [] };
    const access = coupon.customer_access || { enabled: false, emails: [] };
    useEffect(() => {
        if (coupon.use_method === 'auto' && access.enabled)
            onChange({ ...coupon, customer_access: { ...access, enabled: false } });
    }, [coupon.use_method, access.enabled]);
    const changeMode = mode => onChange({ ...coupon, eligibility: { mode, categories: [], brands: [] } });
    const options = scope.mode === 'categories'
        ? categories.map(item => item.category) : brands.map(item => item.brand);
    return <Card sx={{ mb: 2 }}><CardContent>
        <Typography gutterBottom sx={{ fontWeight: 'bold' }}>Productos participantes y clientes</Typography>
        <TextField select fullWidth label="Aplicar el cupón a" value={scope.mode} sx={{ my: 1 }}
            onChange={event => changeMode(event.target.value)}>
            <MenuItem value="all">Todos los productos</MenuItem>
            <MenuItem value="categories">Categorías participantes</MenuItem>
            <MenuItem value="brands">Marcas participantes</MenuItem>
        </TextField>
        {scope.mode !== 'all' && <Autocomplete multiple options={[...new Set(options.filter(Boolean))]}
            value={scope[scope.mode] || []}
            onChange={(event, values) => onChange({ ...coupon, eligibility: { ...scope, [scope.mode]: values } })}
            renderInput={params => <TextField {...params} label={scope.mode === 'categories' ? 'Categorías' : 'Marcas'} />}/>} 
        <Alert severity="info" sx={{ my: 2 }}>
            El descuento, el mínimo de unidades y el monto mínimo consideran solo los productos participantes.
            Cada unidad cuenta. Los demás productos pueden permanecer en el carrito.
        </Alert>
        <FormControlLabel label="Exclusivo para ciertos correos electrónicos"
            control={<Switch checked={access.enabled} disabled={coupon.use_method === 'auto'}
                onChange={event => onChange({ ...coupon, customer_access: { ...access, enabled: event.target.checked } })}/>}/>
        {coupon.use_method === 'auto' && <Typography variant="caption" display="block">La exclusividad por correo requiere aplicación mediante código.</Typography>}
        {access.enabled && <TextField fullWidth multiline minRows={3} label="Correos autorizados"
            value={access.emails.join('\n')} sx={{ mt: 1 }}
            onChange={event => onChange({ ...coupon, customer_access: { ...access, emails: event.target.value.split(/[\n,;]/) } })}
            helperText="Un correo por renglón. El cliente lo introduce al aplicar el cupón y queda fijo en su dirección de envío."/>}
    </CardContent></Card>;
}
